import React, { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./HeaderSection.scss";
import MenuBarsIcon from "../../assets/icons/Menu-Bars";
import CloseXIcon from "../../assets/icons/Close-X";

import { NavLink } from "react-router-dom";
import LoginFormModal from "../LoginFormModal";
import { GameContext, LoginContext } from "context/context";
import { getSlotGames } from "network/game.services";
import { groupBy } from "lodash";
import CustomButton from "components/Common_UI_Kit/CustomButton";
import LogoutIcon from "assets/icons/Logout";
import PasswordEntryModal from "components/PasswordEntry";
import EmailSection from "components/EmailSection";

const navItems = [
  // {
  //   title: "Slot Games",
  //   route: "/slot-games",
  // },
  // {
  //   title: "Fast Games",
  //   route: "/fast-games",
  // },
  {
    title: "Why Us?",
    route: "/why-us",
  },
  {
    title: "Services",
    route: "/services",
  },
];

const Header = () => {
  const { loginData, setLoginData } = useContext(LoginContext);
  const { setGameList, setGameCategories } = useContext(GameContext);

  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  const handleToggle = () => {
    setIsNavigationOpen((prev) => !prev);
  };

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("loginData"));
    if (userData?.user?.id) setLoginData(userData);

    function handleCallback(data) {
      setGameList(data);
      setGameCategories(groupBy(data, "subCategory"));
    }

    const params = {
      page: 1,
      perPage: 100,
    };
    getSlotGames(handleCallback, params);
  }, []);

  const handleLogout = () => {
    setLoginData(null);
    sessionStorage.removeItem("loginData");
  };

  const navAnimation = {
    hidden: { opacity: 0, x: "-100%" },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: "-100%" },
  };

  return (
    <header className="header-section">
      <div className="header-wrap">
        <button className="menu-btn" onClick={handleToggle}>
          {isNavigationOpen ? <CloseXIcon /> : <MenuBarsIcon />}
        </button>

        <NavLink to="/" className="brand-logo-box">
          <img src="/assets/brand-logo/Brand-Logo.svg" alt="Brand Logo" />
        </NavLink>

        <div className="navigation-wrap desktop-navigation-wrap">
          {/* <div className="navigation-box">
            {navItems.map((item) => (
              <NavLink key={item.route} to={item.route} className="nav-link">
                {item.title}
              </NavLink>
            ))}
          </div> */}

          {loginData?.user?.userName ? (
            <div className="btn-box">
              {/* <NavLink to="/contact-us" className="contact-us-btn">
                Contact Us
              </NavLink> */}
              {/* <EmailSection /> */}

              <div className="user-profile-box">
                <div className="img-box">
                  <img src="/assets/stock-img/profile-img.webp" alt="Image" />
                </div>
                <h6 className="user-name-text">{loginData?.user?.userName}</h6>
              </div>

              <CustomButton
                buttonType="primary"
                icon={<LogoutIcon />}
                className="icon-only auth-btn"
                onClick={handleLogout}
              />
            </div>
          ) : (
            <div className="btn-box">
              {/* <NavLink to="/contact-us" className="contact-us-btn">
                Contact Us
              </NavLink> */}
              {/* <EmailSection /> */}


              <LoginFormModal />
            </div>
          )}
        </div>
        <PasswordEntryModal />

        <div className="user-profile-wrap">
          {loginData?.user?.userName ? (
            <div className="btn-box">
              <div className="user-profile-box">
                <div className="img-box">
                  <img src="/assets/stock-img/profile-img.webp" alt="Image" />
                </div>
                <h6 className="user-name-text">{loginData?.user?.userName}</h6>
              </div>

              <CustomButton
                buttonType="primary"
                icon={<LogoutIcon />}
                className="icon-only auth-btn"
                onClick={handleLogout}
              />
            </div>
          ) : (
            <LoginFormModal />
          )}
        </div>

        <AnimatePresence>
          {isNavigationOpen && (
            <motion.div
              className="navigation-wrap mobile-navigation-wrap"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={navAnimation}
              transition={{ type: "tween", duration: 0.3 }}
            >
              <div className="navigation-box">
                {navItems.map((item) => (
                  <NavLink
                    key={item.route}
                    to={item.route}
                    className="nav-link"
                    onClick={handleToggle}
                  >
                    {item.title}
                  </NavLink>
                ))}
              </div>

              <NavLink
                to="/contact-us"
                className="contact-us-btn"
                onClick={handleToggle}
              >
                Contact Us
              </NavLink>
            </motion.div>
          )}
        </AnimatePresence>

        {isNavigationOpen && (
          <div
            className={`sidebar-backdrop ${isNavigationOpen ? "sidebar-backdrop-visible" : ""
              }`}
            onClick={handleToggle}
          />
        )}
      </div>
    </header>
  );
};

export default Header;
